"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  placeholder: '请选择',
  selected: '已选择 ',
  items: ' 项',
  emptyTip: '数据为空'
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud-fe/react-components/lib/components/Select/locale/zh_CN.js
// module id = 1427
// module chunks = 3 6 7 8 10 17 18